// extracted by mini-css-extract-plugin
export default {"modal":"Mla-z","header":"Nla-z","fields":"Ola-z","error":"Pla-z","disabled":"Qla-z","reminderMsg":"Rla-z","errorMsg":"Sla-z","footer":"Tla-z"};